/// <reference path="../_references.ts"/>
module App.DispatchService {

	export type Location = {
		after_hours_end: string;
		after_hours_fee: number;
		after_hours_start: string;
		description: string;
		id: number;
		name: string;
		regular_fee: number;
		visible: boolean;
	}

	export class DispatchService {
		constructor(
			public $http: ng.IHttpService,
			public Constants: IConstants
		){}

		public getLocations(): ng.IHttpPromise<Location[]> {
			return this.$http.get(this.Constants.apiUrl + 'location');
		}

		static factory() {
			let instance = ($http: ng.IHttpService, Constants: IConstants) =>
				new DispatchService($http, Constants);

			instance.$inject = ['$http', 'Constants'];

			return instance;
		}
	}

	angular
        .module('field.dispatch', [])
		.factory('DispatchService', DispatchService.factory());
}